var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('div',{staticClass:"frameSize"},[_vm._v(_vm._s(_vm.renderSize.x)+"x"+_vm._s(_vm.renderSize.y))]),_c('div',{ref:"three",staticClass:"fill-height"})])}
var staticRenderFns = []

export { render, staticRenderFns }